<div class="card-body" >
    <div class="row pad-tb-10">
        <div class="col-md-3">
            <span class="fnt-21">Total Candidates Selected: {{total_student}}  </span>
        </div>
        <div class="col-md-3">
            <span class="fnt-21">  Fees Amount: {{total_amount}}</span>
        </div>
        <div class="col-md-6 align-right">
            <button class="btn btn-warning btn-sm btn-white" (click)="onItiApiRefresh()" [disabled]="import_bool"> Import Candidates </button>
            <button class="btn btn-success btn-sm btn-white" (click)="viewMaster()"> Verify Your Previous Payments  </button>
        </div>
    </div>


    <div class="example-container mat-elevation-z8 tableStud">
        <mat-table #table [dataSource]="dataSource" matSort>

         <!-- Position Column -->
            <ng-container matColumnDef="select" class="mat-column-username">
                <mat-header-cell *matHeaderCellDef mat-sort-header>  
                    <mat-checkbox (change)="showOptions($event)" (change)="$event ? masterToggle() : null"
                    [checked]="isAllSelected()"
                    [indeterminate]="selected_family_member.hasValue() && !isAllSelected()"> Select All
                </mat-checkbox> 
            </mat-header-cell>
                <mat-cell *matCellDef="let element"> 
                    <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="$event ? selected_family_member.toggle(element) : null"
                    [checked]="selected_family_member.isSelected(element)">
      </mat-checkbox>
                </mat-cell>
                
            </ng-container>


            <ng-container matColumnDef="slno">
                <mat-header-cell *matHeaderCellDef mat-sort-header> # </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </mat-cell>
            </ng-container>

            <!-- Position Column -->
            <ng-container matColumnDef="regno">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Register Number </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.RollNumber}} </mat-cell>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="firstname">
                <mat-header-cell *matHeaderCellDef mat-sort-header> First Name    </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.TraineeName}} </mat-cell>
            </ng-container>

             <!-- Symbol Column -->
             <ng-container matColumnDef="trade">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Trade    </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.Trade}} </mat-cell>
            </ng-container>

             <!-- Symbol Column -->
             <ng-container matColumnDef="exam">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Exam    </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.Exam}} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>

        <!-- <mat-paginator  #paginator="matPaginator" [pageSize]="5" [length]="totallength" [pageSizeOptions]="[ 5,10, 25, 50, 100, 500]"></mat-paginator> -->

        <!-- <mat-paginator #paginator="matPaginator"  [length]="totallength" (page)="pageEvent = $event; pageChanged($event)" [pageSizeOptions]="[ 5]"></mat-paginator> -->

    </div>

    <div class="row pad-tb-10">
 
     
        <div class="col-md-12 align-right">
            <button class="btn btn-success" [disabled]="bool_paynow" (click)="logSelection()"> Pay Now </button>
        </div>
    </div>


</div>